export enum PaymentRefundReason {
	NotSet = 0,
	EventCancellationOrPostponement = 1,
	CustomerDissatisfaction = 3,
	SystemOrOperationalError = 4,
	Other = 5,
	TestRefund = 6,
	TicketChangeRequest = 7
}



// WEBPACK FOOTER //
// ./src/app/models/payment-refund-reason.enum.ts